import { ObjectHelpers } from "../../helpers/object-helpers";
import { ChartStyleColorModel } from "../chart-style/chart-style-color.model";

export class LimitAlertModel {

    public id = '';
    public price = 0;
    public imageAnnotationName = '';
    public status = '';
    public tooltip = '';
    public symbol = '';
    public created?: Date;
    public triggered?: Date;
    public color = new ChartStyleColorModel();
    // public preCreate = false;
    
    constructor(data?: any) {
        if (data) {
            this.cast(data);
        }
    }

    private cast(data: any) {
        ObjectHelpers.setProperties(data, this, true);
        this.color = new ChartStyleColorModel(data.color);
    }

    public getImage(basePath: string): string {
        if (this.imageAnnotationName == 'WORKING') {
            return basePath + 'assetfiles/img/light_blue_pin.png';
        } else if (this.imageAnnotationName == 'EXPIRED') {
            return  basePath + 'assetfiles/img/light_purple_pin.png';
        } else if (this.imageAnnotationName == 'INVALIDATED') {
            return  basePath + 'assetfiles/img/light_red_pin.png';
        } else if (this.imageAnnotationName == 'TRIGGERED') {
            return  basePath + 'assetfiles/img/light_green_pin.png';
        }
        
        return '';
    }

    public isTriggered(): boolean {
        return this.imageAnnotationName == 'TRIGGERED';
    }
}